<template>
  <div style="clear:both;">
    <v-card :color="backgroundColor">
      <v-toolbar v-if="!readonly" elevation="8" density="compact" :color="backgroundColor">
        <v-toolbar-title>{{ $t('Initiator_Actions') }}</v-toolbar-title>
      </v-toolbar>
      <v-form ref="initiatorForm" :value="valid" autocomplete="off">
        <template v-if="!readonly && !isMakePermanent && !isExtend">
          <void :moc="moc" role="initiator"></void>
        </template>

        <template v-if="!readonly">
          <template v-if="canMakeRevision && (availableForDecisionStatus || pendingOwnerDecisionStatus)">
            <v-dialog v-model="revisionReasonDialog" persistent max-width="600px">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn dark v-bind="activatorProps" color="accent" class="ma-2" v-if="!ownerApproved"> <span style="color: white !important;">{{ $t('Make_Revisions') }}</span></v-btn>
              </template>
              <v-card>
                <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline </v-icon></v-toolbar>
                <v-card-text class="text-h6 font-weight-bold">{{ $t('Revision_Reason') }}</v-card-text>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-form ref="revisionReasonMo" v-model="valid" lazy-validation autocomplete="off">
                          <v-textarea
                            v-model="revisionReason"
                            name="revisionReason"
                            variant="underlined"
                            :rules="revisionReasonRules"
                            auto-grow
                          ></v-textarea>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="card-button" text @click="revisionReasonDialog = false">{{ $t('Cancel') }}</v-btn>
                  <v-btn color="primary" class="card-button" text @click="makeRevisions()">{{ $t('Make_Revisions') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </template>
      </v-form>
    </v-card>
    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import MOCService from '@/services/moc.service'
import { AdvanceType } from '@/common/systemTypes'
import Void from '@/components/mocForm/Void'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
import { Flags } from '@/common/flags'
import { DecisionTypes } from '@/common/types'

export default {
  name: 'InitiatorActions',
  data: () => ({
    valid: true,
    revisionReasonDialog: false,
    revisionReason: ''
  }),
  props: {
    roles: {
      type: Array,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    moc: {
      type: Object
    }
  },
  components: {
    Void,
    Toaster,
    LoadingDialog
  },
  methods: {
    async makeRevisions() {
      const result = await this.$refs.revisionReasonMo.validate();
      if (result.valid) {      
        this.moc.revisionReason = { reason: this.revisionReason }
        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.REVISION)
          .then(result => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.revisionReasonDialog = false
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_MakeRevisionsSaved') })
          })
          .catch(e => {
            this.$refs.loadingDialog.error({
              metadata: 'makeRevisions',
              error: e,
              message: this.$t('Error_MakeRevisions')
            })
          })
      }
    }
  },
  computed: {
    isMakePermanent() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.MAKEPERMANENT].key)
    },
    isExtend() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.EXTEND].key)
    },
    availableForDecisionStatus: function() {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value) {
        return true
      }
      return false
    },
    backgroundColor() {
      return this.readonly ? 'backgroundReadOnly' : 'backgroundEditable'
    },
    canMakeRevision: function() {
      if (this.isMakePermanent || this.isExtend) {
        return false
      }
      return (this.moc.revisionHistory || []).length < 2
    },
    ownerApproved: function() {
      return ((this.moc.ownerDecision || {}).decision || {}).key === DecisionTypes.properties[DecisionTypes.APPROVED].key
    },
    pendingOwnerDecisionStatus: function() {
      if (this.mocFormStatus === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) {
        return true
      }
      return false
    },
    readonly: function() {
      switch (this.mocFormStatus) {
        case FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value:
        case FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value:
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
        case FormStatus.properties[FormStatus.BEINGREVISED].value: {
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        }
        default:
          return true
      }
    },
    closedVoidReasonRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required_VoidReason')]
      }
    },
    revisionReasonRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required_Revision')]
      }
    }
  }
}
</script>

<style scoped></style>
